import { put } from 'redux-saga/effects';
import API from '@utils/api';
import { filterOutList } from '@utils/filters';
import RegionsActions from './RegionsRedux';
import logger from '@utils/logger';

export function* fetchRegions() {
  yield put(RegionsActions.setRegionsLoading(true));
  try {
    const { result: regions } = yield API.fetchRegions();

    const activeRegions = regions.filter(region => region.propertiesCount > 0);

    yield put(RegionsActions.setRegions(activeRegions));
    yield put(RegionsActions.updateRegionFilterList(filterOutList(regions)));
    yield put(RegionsActions.setRegionsLoading(false));
  } catch (err) {
    logger.error('err: ', err);
  }
}

export function* fetchRegion(actions) {
  const { regionId } = actions;
  yield put(RegionsActions.setRegionsLoading(true));
  try {
    const { result: report } = yield API.fetchRegion(regionId);
    const regionalHousekeepers = yield API.fetchRegionHks(regionId);
    report.housekeepers = regionalHousekeepers.result;
    report.properties.forEach(p =>
      p.housekeepers.sort((a, b) => (a.weight > b.weight ? -1 : 1))
    );
    yield put(RegionsActions.setRegionData(report));
  } catch (err) {
    logger.error('err: ', err);
  }
  yield put(RegionsActions.setRegionsLoading(false));
}
